import { h } from 'preact';

export const LogicHOC = logic => UIComponent => function ComponentLogicHOC (props) {
    return <UIComponent {...logic(props)} />;
};